<app-navbar-white></app-navbar-white>
<div class="spinner-container-box" *ngIf="Loader">
    <div class="spinner-container">
      <div class="spinner-border spinner-border-sm" role="status"></div>
      <div class="text-loader">
        Please wait while we are gathering data...
      </div>
   </div>
</div>
<div class="section-conatiner" *ngIf="!Loader">
<div class="width-r container-fluid">
<div class="resource-section">
<img loading="eager" class="img-fluid lazyload" id="section-bg" src="{{Article?.data?.showPageImageLink?.iv}}" alt="image not found">
</div>

<div class="row">
<div class="col-md-9 col-lg-9 col-sm-12">  
<div class="d-flex">
<div class="tittle-article">{{Article.data?.category?.categoryText[0]}}</div>
<div class="d-flex  width-box"><img loading="eager" class="img-fluid lazyload img-box" src="{{imgSrc}}Vector-clock.svg" alt="image not found"><div class="mins-count">{{Article.data?.readTime?.iv}} read</div>
</div>
</div>
<div class="box-heading">{{Article.data?.articleTitle?.iv}}</div>
<div class="txt-simple">{{Article.data?.subheading?.iv}}</div>
<div class="txt-para" [innerHTML]="Article?.data?.articleText?.iv" (click)="AnchorClick($event)">
</div>
</div>
<div class="col-md-3 col-lg-3 col-sm-12 padding-box-new">
<div class="author-txt">Author</div>
<div class="author-heading">{{Article?.data?.author?.iv}}</div>
<div class="marginset">
<div class="share-txt">Share</div>
<div class="d-flex d-m">
<img loading="lazy" (click)="redirect('facebook')" class="img-fluid lazyload img-social" src="{{imgSrc}}fb.svg" alt="image not found">
<img loading="lazy" (click)="redirect('pinterest')" class="img-fluid lazyload img-social" src="{{imgSrc}}pinterest.svg" alt="image not found">
<img loading="lazy" (click)="redirect('twitter')" class="img-fluid lazyload img-social" src="{{imgSrc}}skype-d.svg" alt="image not found">
</div></div>
<div class="rel-article-txt">Related Articles</div>

<div class="drop-shadow-box" *ngFor="let refArticle of relatedArticles">
<div class="d-flex">
<div class="tittle-article">{{refArticle?.category?.categoryText[0]}}</div>
<div class="d-flex  width-box"><img loading="lazy" class="img-fluid lazyload img-box" src="{{imgSrc}}Vector-clock.svg" alt="image not found"><div class="mins-count">{{refArticle?.readTime?.iv}} read</div>
</div>
</div>
<div class="para-txt" (click)="DisplayRelatedArticle(refArticle?.id)">{{refArticle?.articleTitle?.iv}}</div>
<div class="read-txt" (click)="DisplayRelatedArticle(refArticle?.id)">READ</div>
</div>

</div>
</div>
</div>


</div>
<app-footer-new></app-footer-new>